import React from 'react'
import { Col, Row } from 'reactstrap'
import componentStyles from './index.module.scss'
import styles from "../../dashboard.module.scss";
import classNames from "classnames";

const VideoWhereUsedInfo = ({ video }) => {
  return (
    <>
      <Row>
        <Col xs="2">
            <p
              className={styles.tableTitle}
            >
              Courses:
            </p>
        </Col>
        <Col xs="10">
            <p
              className={classNames(styles.tableTitle, "d-flex flex-wrap")}
            >
              {video.courses.map(course => {
                return (<span className={classNames(componentStyles.videoLibraryTags, 'mr-1')}>
                {course.title}
              </span>)
              })}
            </p>
        </Col>
      </Row>
      <Row>
        <Col xs="2">
            <p
              className={styles.tableTitle}
            >
              Lessons:
            </p>
        </Col>
        <Col xs="10">
            <p
              className={classNames(styles.tableTitle, "d-flex flex-wrap")}
            >
              {video.lessons.map(lesson => {
                return (<span className={classNames(componentStyles.videoLibraryTags, 'mr-1')}>
                {lesson.title}
              </span>)
              })}
            </p>
        </Col>
      </Row>
      <Row>
        <Col xs="2">
            <p
              className={styles.tableTitle}
            >
              Premium Article:
            </p>
        </Col>
        <Col xs="10">
            <p
              className={classNames(styles.tableTitle, "d-flex flex-wrap")}
            >
              {video.premiumArticles.map(premiumArticle => {
                return (<span className={classNames(componentStyles.videoLibraryTags, 'mr-1')}>
                {premiumArticle.title}
              </span>)
              })}
            </p>
        </Col>
      </Row>
    </>
    
  )
}

export default VideoWhereUsedInfo;